import React from "react";
import locationIcon from "../../../assets/svg/EPL_think_svg/location.svg";
import ScenarioBasedBottomModal from "./ScenarioBasedBottomModal";
import ScenarioBasedModal from "./ScenarioBasedModal";

const EmandateVerificationPendingModal = ({ isOpen, onClose }) => (
  <ScenarioBasedModal
    id="bd-otp-sent"
    isOpen={isOpen}
    onClose={onClose}
    modalIcon="&#10004;"
    showCloseButton={false}
    modalMessage={
      "Your Emandate Verification is pending.\nPlease come after some time."
    }
    onModalSubmit={onClose}
    removeButton={true}
  />
);

const LocationCaptureModal = ({
  isOpen,
  onClose,
  onModalSubmit,
  locationMessage,
}) => (
  <ScenarioBasedBottomModal
    id="bd-capture-modal"
    isOpen={isOpen}
    onClose={onClose}
    modalImage={locationIcon}
    // modalIcon="&#10004;"
    modalMessageHeading={"Location Access Required!"}
    modalMessage={
      "To continue, please allow access to your location from your browser settings. This is required for KYC purpose."
    }
    modalSubmitMessage={"Get My Location"}
    onModalSubmit={onModalSubmit}
    additionalMesssage={locationMessage}
  />
);

const SelfiePermissionCaptureModal = ({
  isOpen,
  onClose,
  onModalSubmit,
  locationMessage,
}) => (
  <ScenarioBasedBottomModal
    id="bd-capture-modal"
    isOpen={isOpen}
    onClose={onClose}
    modalImage={locationIcon}
    // modalIcon="&#10004;"
    modalMessageHeading={"Camera Permission Required!"}
    modalMessage={
      "To continue, please allow access to your Camera from your browser settings."
    }
    modalSubmitMessage={"Get Camera access"}
    onModalSubmit={onModalSubmit}
    additionalMesssage={locationMessage}
  />
);

const OtpSentModal = ({ mobileNumber, isOpen, onClose }) => (
  <ScenarioBasedModal
    id="bd-otp-sent"
    isOpen={isOpen}
    onClose={onClose}
    modalIcon="&#10004;"
    modalMessage={
      "We have sent an OTP to your mobile number ******" + mobileNumber + "."
    }
    onModalSubmit={onClose}
  />
);

const ResendOtpModal = ({ mobileNumber, isOpen, onClose }) => (
  <ScenarioBasedModal
    id="bd-otp-sent"
    isOpen={isOpen}
    onClose={onClose}
    modalIcon="&#10004;"
    showCloseButton={false}
    modalMessage={
      "We have sent an OTP to your mobile number ******" + mobileNumber + "."
    }
    onModalSubmit={onClose}
  />
);

const ResendOtpEmailModal = ({ isOpen, onClose }) => (
  <ScenarioBasedModal
    id="bd-otp-sent"
    isOpen={isOpen}
    onClose={onClose}
    modalIcon="&#10004;"
    showCloseButton={false}
    modalMessage={"We have sent an OTP to your registered official email ID"}
    onModalSubmit={onClose}
  />
);

const PerfiosRetrieveReportsRetryModal = ({ isOpen, onClose }) => (
  <ScenarioBasedModal
    id="bd-otp-sent"
    isOpen={isOpen}
    onClose={onClose}
    modalIcon="&#10004;"
    showCloseButton={false}
    modalMessage={
      "It’s taking longer than usual. Please try again after some time"
    }
    onModalSubmit={onClose}
  />
);

const EmandateRetryModal = ({ isOpen, onClose }) => (
  <ScenarioBasedModal
    id="bd-otp-sent"
    isOpen={isOpen}
    onClose={onClose}
    modalIcon="&#10004;"
    showCloseButton={false}
    modalMessage={
      "There seems to be a technical glitch.Please try again after some time."
    }
    onModalSubmit={onClose}
  />
);

const ForeclosureChargesModal = ({ isOpen, onClose }) => (
  <ScenarioBasedModal
    id="bd-otp-sent"
    isOpen={isOpen}
    onClose={onClose}
    modalIcon="&#10004;"
    showCloseButton={false}
    modalMessage={
      "There seems to be a technical glitch.Please try again after some time."
    }
    onModalSubmit={onClose}
  />
);

const DSAsyncRetryModal = ({ isOpen, onClose }) => (
  <ScenarioBasedModal
    id="bd-otp-sent"
    isOpen={isOpen}
    onClose={onClose}
    modalIcon="&#10004;"
    showCloseButton={false}
    modalMessage={
      "It’s taking longer than usual. Please try again after some time"
    }
    onModalSubmit={onClose}
  />
);

const IncorrectOtpModal = ({ isOpen, onClose }) => (
  <ScenarioBasedModal
    id="bd-otp-sent"
    isOpen={isOpen}
    onClose={onClose}
    modalIcon="&#10008;"
    modalMessage={"You have entered an incorrect OTP"}
    onModalSubmit={onClose}
  />
);

const IncorrectPinCodeModal = ({ isOpen, onClose }) => (
  <ScenarioBasedModal
    id="bd-incorrect-pincode"
    isOpen={isOpen}
    onClose={onClose}
    modalIcon="&#10008;"
    modalMessage={"Enter valid Pincode, entered Pincode is not serviceable"}
    onModalSubmit={onClose}
  />
);

const CompanyCategoryReject = ({ isOpen, onClose }) => (
  <ScenarioBasedModal
    id="bd-company-category-reject"
    isOpen={isOpen}
    onClose={onClose}
    modalIcon="&#10008;"
    modalMessage={
      "We thank you for your interest. Unfortunately we cannot proceed with your application as it does not comply with our policy guidelines. We regret the inconvenience."
    }
    onModalSubmit={onClose}
  />
);

const KarzaFailed = ({ isOpen, onClose }) => (
  <ScenarioBasedModal
    id="bd-incorrect-pincode"
    isOpen={isOpen}
    onClose={onClose}
    modalIcon="&#10008;"
    modalMessage={
      "We thank you for your interest. Unfortunately we cannot proceed with your application as it does not comply with our policy guidelines. We regret the inconvenience."
    }
    onModalSubmit={onClose}
  />
);

const IncomeFailed = ({ isOpen, onClose }) => (
  <ScenarioBasedModal
    id="bd-incorrect-pincode"
    isOpen={isOpen}
    onClose={onClose}
    modalIcon="&#10008;"
    modalMessage={
      "We are sorry we cannot proceed with your application at this point in time."
    }
    onModalSubmit={onClose}
  />
);

const DsEligibilityFailed = ({ isOpen, onClose }) => (
  <ScenarioBasedModal
    id="bd-incorrect-pincode"
    isOpen={isOpen}
    onClose={onClose}
    modalIcon="&#10008;"
    modalMessage={
      "We thank you for your interest. Unfortunately we cannot proceed with your application as it does not comply with our policy guidelines. We regret the inconvenience."
    }
    onModalSubmit={onClose}
  />
);

const CePollingFailed = ({ isOpen, onClose }) => (
  <ScenarioBasedModal
    id="bd-incorrect-pincode"
    isOpen={isOpen}
    onClose={onClose}
    modalIcon="&#10008;"
    modalMessage={
      "We thank you for your interest. Unfortunately we cannot proceed with your application as it does not comply with our policy guidelines. We regret the inconvenience."
    }
    onModalSubmit={onClose}
  />
);

const OtpExpiredModal = ({ isOpen, onClose }) => (
  <ScenarioBasedModal
    id="bd-otp-sent"
    isOpen={isOpen}
    onClose={onClose}
    modalSubmitMessage="RE-SEND OTP"
    modalIcon="&#10008;"
    modalMessage={"Your OTP has Expired. Please Try Again!"}
    onModalSubmit={onClose}
  />
);

const NoOfferFoundModal = ({ isOpen, onClose, modalImage }) => (
  <ScenarioBasedModal
    id="bd-otp-sent"
    style={{ fontSize: "25px" }}
    isOpen={isOpen}
    onClose={onClose}
    modalImage={modalImage}
    modalMessage={" Sorry! No Offer Found"}
    onModalSubmit={onClose}
  />
);


const InvalidURLModal = ({ isOpen, onClose, modalImage }) => (
	<ScenarioBasedModal
		id="bd-otp-sent"
		style={{ fontSize: "25px" }}
		isOpen={isOpen}
		modalImage={modalImage}
		removeButton={true}
		onClose={onClose}
		modalMessage={" Please Use Valid URL! "}
	/>
);

const InvalidHashModal = ({ isOpen, onClose, modalImage }) => (
  <ScenarioBasedModal
    id="bd-otp-sent"
    style={{ fontSize: "25px" }}
    isOpen={isOpen}
    onClose={onClose}
    modalImage={modalImage}
    modalMessage={" Please Use Valid URL! "}
    onModalSubmit={onClose}
  />
);

const MaxOtpRetryModal = ({ isOpen, onClose }) => (
  <ScenarioBasedModal
    id="bd-otp-sent"
    isOpen={isOpen}
    onClose={onClose}
    modalIcon="&#10008;"
    modalMessage={
      "Cannot send OTP more than 3 times. Please retry after 15 mins for new OTP."
    }
    onModalSubmit={onClose}
  />
);

const MaxVerifyOtpRetryModal = ({ isOpen, onClose }) => (
  <ScenarioBasedModal
    id="bd-otp-sent"
    isOpen={isOpen}
    onClose={onClose}
    modalIcon="&#10008;"
    modalMessage={
      "Cannot verify OTP more than 3 times. Please retry after 15 mins for new OTP."
    }
    onModalSubmit={onClose}
  />
);

const SelfEmpWarnModal = ({ isOpen, onClose, modalImage }) => (
  <ScenarioBasedModal
    showCloseButton={false}
    id="bd-otp-sent"
    isOpen={isOpen}
    modalImage={modalImage}
    onClose={onClose}
    modalMessage={
      "Sorry, on the basis of provided information we cannot proceed with your application right now"
    }
    onModalSubmit={onClose}
  />
);

const DigilockerMovingModal = ({ isOpen, onClose, modalImage }) => (
  <ScenarioBasedModal
    id="bd-otp-sent"
    isOpen={isOpen}
    onClose={onClose}
    modalImage={modalImage}
    modalMessageHeading={"Oops, we are sorry!"}
    modalMessage={"Moving the application to DigiLocker for KYC."}
    onModalSubmit={onClose}
  />
);

const UploadSelfieFailedModal = ({ isOpen, onClose, modalMessage }) => (
  <ScenarioBasedModal
    showCloseButton={false}
    id="bd-otp-sent"
    isOpen={isOpen}
    onClose={onClose}
    modalIcon="&#10008;"
    modalMessage={modalMessage}
    onModalSubmit={onClose}
  />
);

const CkycFailedModal = ({ isOpen, onClose, modalImage }) => (
  <ScenarioBasedModal
    id="bd-otp-sent"
    isOpen={isOpen}
    onClose={onClose}
    modalImage={modalImage}
    modalMessageHeading={"Oops, we are sorry!"}
    modalMessage={"Declared Name and Address Mismatched with the Documents."}
    onModalSubmit={onClose}
  />
);

const OkycFailedModal = ({ isOpen, onClose, modalImage }) => (
  <ScenarioBasedModal
    id="bd-otp-sent"
    isOpen={isOpen}
    onClose={onClose}
    modalImage={modalImage}
    modalMessageHeading={"Oops, we are sorry!"}
    modalMessage={"Declared Name and Address Mismatched with the Documents."}
    onModalSubmit={onClose}
  />
);

const PerfiosRetrieveReportsFailedModal = ({ isOpen, onClose, modalImage }) => (
  <ScenarioBasedModal
    id="bd-otp-sent"
    isOpen={isOpen}
    onClose={onClose}
    modalImage={modalImage}
    modalMessageHeading={"Oops, we are sorry!"}
    modalMessage={
      "We thank you for your interest. Unfortunately we cannot proceed with your application as it does not comply with our policy guidelines. We regret the inconvenience."
    }
    onModalSubmit={onClose}
  />
);

const CePollingFailedModal = ({ isOpen, onClose, modalImage }) => (
  <ScenarioBasedModal
    id="bd-otp-sent"
    isOpen={isOpen}
    onClose={onClose}
    modalImage={modalImage}
    modalMessageHeading={"Oops, we are sorry!"}
    modalMessage={
      "We thank you for your interest. Unfortunately we cannot proceed with your application as it does not comply with our policy guidelines. We regret the inconvenience."
    }
    onModalSubmit={onClose}
  />
);

const EmandateFailedModal = ({ isOpen, onClose, modalImage }) => (
  <ScenarioBasedModal
    id="bd-otp-sent"
    isOpen={isOpen}
    onClose={onClose}
    modalImage={modalImage}
    modalMessageHeading={"Oops, we are sorry!"}
    modalMessage={
      "Maximum attempts exhausted. We cannot process your application right now. Our customer service team will get in touch with you shortly."
    }
    onModalSubmit={onClose}
  />
);

const RejectNameMatchModal = ({ isOpen, onClose }) => (
  <ScenarioBasedModal
    id="bd-otp-sent"
    isOpen={isOpen}
    onClose={onClose}
    modalIcon="&#10004;"
    showCloseButton={false}
    modalMessage={
      "We thank you for your interest. Unfortunately we cannot proceed with your application as it does not comply with our policy guidelines. We regret the inconvenience"
    }
    onModalSubmit={onClose}
  />
);

const ZumigoFailed = ({ isOpen, onClose, modalImage }) => (
  <ScenarioBasedModal
    id="bd-otp-sent"
    isOpen={isOpen}
    onClose={onClose}
    modalImage={modalImage}
    modalMessageHeading={"Oops, we are sorry!"}
    modalMessage={
      "We thank you for your interest. Unfortunately we cannot proceed with your application as it does not comply with our policy guidelines. We regret the inconvenience."
    }
    onModalSubmit={onClose}
  />
);

const FaceMatchModal = ({ isOpen, onClose, modalImage }) => (
  <ScenarioBasedModal
    id="bd-otp-sent"
    isOpen={isOpen}
    onClose={onClose}
    modalImage={modalImage}
    modalMessageHeading={"Oops, we are sorry!"}
    modalMessage={
      "We thank you for your interest. Unfortunately we cannot proceed with your application as it does not comply with our policy guidelines. We regret the inconvenience"
    }
    onModalSubmit={onClose}
  />
);

const BankDetailsIncorrect = ({ isOpen, onClose }) => (
  <ScenarioBasedModal
    id="bd-otp-sent"
    isOpen={isOpen}
    onClose={onClose}
    modalIcon="&#10008;"
    modalMessage={
      "Please enter same bank account details as bank statement provided at the previous stage."
    }
    onModalSubmit={onClose}
  />
);
const NsdlPanFailed = ({ isOpen, onClose }) => (
  <ScenarioBasedModal
    id="bd-otp-sent"
    isOpen={isOpen}
    onClose={onClose}
    modalIcon="&#10008;"
    removeButton={false}
    modalSubmitMessage={"Retry"}
    modalMessage={"Please enter your correct PAN."}
    onModalSubmit={onClose}
  />
);

const SafariCheckModal = ({ isOpen, onClose }) => (
  <ScenarioBasedModal
    id="bd-otp-sent"
    isOpen={isOpen}
    onClose={onClose}
    modalMessageHeading={
      "We recommend using Chrome brower for better experience."
    }
    // modalMessage={"Open the URL in chrome browser."}
    onModalSubmit={onClose}
  />
);

const CheckInternetModal = ({ isOpen, onClose }) => (
  <ScenarioBasedModal
    id="bd-otp-sent"
    isOpen={isOpen}
    onClose={onClose}
    modalIcon="&#10008;"
    modalMessage={"Please check your internet connection"}
    onModalSubmit={onClose}
  />
);

const DesktopModeCheckModal = ({ isOpen, onClose, modalImage }) => (
  <ScenarioBasedModal
    id="bd-otp-sent"
    isOpen={isOpen}
    onClose={onClose}
    modalImage={modalImage}
    modalMessageHeading={"Use Mobile Device to continue!"}
    modalMessage={"Open the URL in your mobile."}
    removeButton={true}
    onModalSubmit={onClose}
  />
);

const PerfiosStatusRetryModal = ({ isOpen, onClose }) => (
	<ScenarioBasedModal
		id="bd-otp-sent"
		isOpen={isOpen}
		onClose={onClose}
		// modalIcon="&#10004;"
		showCloseButton={true}
		modalMessage={"Previous attempt got failed. Please try again."}
		onModalSubmit={onClose}
	/>
);

const RejectActivePANModal = ({ isOpen, onClose }) => (
  <ScenarioBasedModal
    id="bd-otp-sent"
    isOpen={isOpen}
    onClose={onClose}
    modalIcon="&#10008;"
    showCloseButton={true}
    modalMessage={
      "More than 1 active application already exist for this PAN"
    }
    onModalSubmit={onClose}
  />
);

const InvalidCaptchaModal = ({ isOpen, onClose, modalImage }) => (
  <ScenarioBasedModal
    id="bd-otp-sent"
    style={{ fontSize: "25px" }}
    isOpen={isOpen}
    onClose={onClose}
    modalImage={modalImage}
    modalMessage={" Invalid Captcha Token! "}
    onModalSubmit={onClose}
  />
);

const PennyDropModal = ({ isOpen, onClose, msg }) => (
  <ScenarioBasedModal
    id="bd-company-category-reject"
    isOpen={isOpen}
    onClose={onClose}
    modalIcon="&#10008;"
    modalMessage={msg}
    onModalSubmit={onClose}
    showCloseButton={false}
    closeonClickOutside={false}
  />
);

const PanValidationReject = ({ isOpen, onClose, modalImage }) => (
  <ScenarioBasedModal
    id="bd-otp-sent"
    isOpen={isOpen}
    onClose={onClose}
    modalImage={modalImage}
    modalMessageHeading={"Oops, we are sorry!"}
    modalMessage={
      "We thank you for your interest. Unfortunately we cannot proceed with your application as it does not comply with our policy guidelines. We regret the inconvenience"
    }
    onModalSubmit={onClose}
  />
);

const NsdlApiDown = ({ isOpen, onClose }) => (
  <ScenarioBasedModal
    id="bd-otp-sent"
    isOpen={isOpen}
    onClose={onClose}
    modalIcon="&#10008;"
    removeButton={false}
    modalSubmitMessage={"Retry"}
    modalMessage={"The PAN verification could not be completed. Please try after some time."}
    onModalSubmit={onClose}
  />
);

const VideoKycMovingModal = ({ isOpen, onModalSubmit, onClose }) => (
  <ScenarioBasedModal
    id="bd-otp-sent"
    isOpen={isOpen}
    onClose={onClose}
    modalMessageHeading={"“Keep your original PAN card ready”"}
    modalMessage={"You will be redirected to complete your video KYC process."}
    modalSubmitMessage="Click to Proceed"
    onModalSubmit={onModalSubmit}
    showCloseButton={false}
    closeonClickOutside={false}
  />
);

const VerifyNameOnPANModal = ({ isOpen, onClose, name }) => (
  <ScenarioBasedModal
    id="bd-otp-sent"
    isOpen={isOpen}
    onClose={onClose}
    modalMessageHeading={"Attention !"}
    // modalIcon="&#10008;"
    modalMessage={`Dear Customer, your correct name as per PAN is ${name}. Please proceed with the journey.`}
    onModalSubmit={onClose}
    showCloseButton={false}
    closeonClickOutside={false}
  />
);

const BankUdyamMismatchModal = ({ isOpen, onClose }) => (
  <ScenarioBasedModal
    id="bd-otp-sent"
    isOpen={isOpen}
    onClose={onClose}
    modalMessage={"The bank details do not align with the information provided in your business documents."}
    onModalSubmit={onClose}
    showCloseButton={false}
    closeonClickOutside={false}
  />
);

export {
  BankDetailsIncorrect,
  CePollingFailed,
  CePollingFailedModal,
  CheckInternetModal,
  CkycFailedModal,
  CompanyCategoryReject,
  DSAsyncRetryModal,
  DesktopModeCheckModal,
  PerfiosStatusRetryModal,
  DigilockerMovingModal,
  DsEligibilityFailed,
  EmandateFailedModal,
  EmandateRetryModal,
  EmandateVerificationPendingModal,
  FaceMatchModal,
  ForeclosureChargesModal,
  IncomeFailed,
  IncorrectOtpModal,
  IncorrectPinCodeModal, InvalidCaptchaModal, InvalidHashModal,
  InvalidURLModal,
  KarzaFailed,
  LocationCaptureModal,
  MaxOtpRetryModal,
  MaxVerifyOtpRetryModal,
  NoOfferFoundModal, NsdlPanFailed, OkycFailedModal,
  OtpExpiredModal,
  OtpSentModal, PennyDropModal, PerfiosRetrieveReportsFailedModal,
  PerfiosRetrieveReportsRetryModal, RejectActivePANModal, RejectNameMatchModal,
  ResendOtpEmailModal,
  ResendOtpModal,
  SafariCheckModal,
  SelfEmpWarnModal,
  UploadSelfieFailedModal,
  ZumigoFailed,
  PanValidationReject,
  NsdlApiDown,
  VideoKycMovingModal,
  VerifyNameOnPANModal,
  BankUdyamMismatchModal,
  SelfiePermissionCaptureModal
};

